/** Dismissable-by-fix error banner with a retry action (DESIGN.md §9 Error/Stale states). */
export class ErrorBanner {
  readonly element: HTMLElement;
  private readonly textEl: HTMLSpanElement;

  constructor(onRetry: () => void) {
    this.element = document.createElement("div");
    this.element.className = "error-banner card";
    this.element.setAttribute("role", "alert");
    this.element.hidden = true;

    this.textEl = document.createElement("span");
    this.textEl.className = "error-banner__text";

    const retryBtn = document.createElement("button");
    retryBtn.type = "button";
    retryBtn.className = "error-banner__retry";
    retryBtn.textContent = "Spróbuj ponownie";
    retryBtn.setAttribute("aria-label", "Spróbuj ponownie pobrać dane radaru");
    retryBtn.addEventListener("click", onRetry);

    this.element.append(this.textEl, retryBtn);
  }

  show(message: string): void {
    this.textEl.textContent = message;
    this.element.hidden = false;
  }

  hide(): void {
    this.element.hidden = true;
  }
}
